import React from "react";
import "./home.css";
import { Link } from "react-router-dom";

// image
import Logo from "../../assets/images/logo.jpg";

// icons
import { BsFillCircleFill } from "react-icons/bs";
import { SlArrowRight } from "react-icons/sl";
import { TbEditCircle, TbCloudUpload } from "react-icons/tb";

function Home() {
  return (
    <div className="Home">
      <div className="header">
        <h1>Administration</h1>
      </div>
      <div className="wrapper">
        <div className="status">
          <div className="left">
            <img src={Logo} alt="" />
            <div className="text">
              <div className="title">Titoumr</div>
              <div className="url">www.titoumr.fr</div>
            </div>
          </div>
          <div className="right good">
            <BsFillCircleFill className="icon" /> Parfait
          </div>
        </div>
        <div className="group">
          <div className="title-header">PHOTOS</div>
          <Link to="/image/upload" className="upload-image container">
            <div className="left">
              <div className="icon">
                <TbCloudUpload className="icon" />
              </div>
              <div className="ctn-text">
                <div className="title">Ajouter une ou plusieurs images</div>
                <div className="text">
                  Vos images seront compréssé et signé et seront automatiquement
                  publié
                </div>
              </div>
            </div>
            <div className="right">
              <SlArrowRight className="icon" />
            </div>
          </Link>
          <Link to="/image/manage" className="manage-image container">
            <div className="left">
              <div className="icon">
                <TbEditCircle className="icon" />
              </div>
              <div className="ctn-text">
                <div className="title">Modifier, supprimer vos images</div>
                <div className="text">
                  Ajouter une description ou des tags ou alors supprimer l'image
                </div>
              </div>
            </div>
            <div className="right">
              <SlArrowRight className="icon" />
            </div>
          </Link>
        </div>
      </div>
      <div className="footer"></div>
    </div>
  );
}

export default Home;
